import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { api, clearAccessToken, getAccessToken } from '@/api/client';
import type { AuthMeProfile } from '@/api/services/auth';
import { ToastProvider } from '@/components/Toast';
import { MeProvider } from '@/context/MeContext';
import AcceptTermsPage from '@/pages/AcceptTerms';

type SessionState =
  | { phase: 'loading' }
  | { phase: 'unauthenticated' }
  | { phase: 'ready'; profile: AuthMeProfile };

export default function RestrictedAcceptTermsApp() {
  const [session, setSession] = useState<SessionState>({ phase: 'loading' });

  useEffect(() => {
    const token = getAccessToken();
    if (!token) {
      setSession({ phase: 'unauthenticated' });
      return;
    }
    api.auth
      .me()
      .then((profile) => setSession({ phase: 'ready', profile }))
      .catch(() => {
        clearAccessToken();
        setSession({ phase: 'unauthenticated' });
      });
  }, []);

  if (session.phase === 'loading') {
    return (
      <div className="loading-screen">
        <div className="spinner" />
        <span>Loading…</span>
      </div>
    );
  }
  if (session.phase === 'unauthenticated') {
    return <Navigate to="/login" replace />;
  }
  if (!session.profile.termsAcceptanceRequired) {
    return <Navigate to="/" replace />;
  }

  return (
    <ToastProvider>
      <MeProvider initialProfile={session.profile}>
        <AcceptTermsPage />
      </MeProvider>
    </ToastProvider>
  );
}
